/**
 * Changes made:
 * - 2025-09-27: Created BackgroundVector component for hero section left-side vector shape
 * - 2025-09-28: Converted from solid background div to proper SVG with path "M0 539V0H947L645.867 539H0Z"
 */

export const BackgroundVector = () => {
  return (
    <div 
      data-svg-wrapper 
      data-layer="Vector 1" 
      className="Vector1 left-0 top-0 absolute"
    >
      <svg width="947" height="539" viewBox="0 0 947 539" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 539V0H947L645.867 539H0Z" fill="#B51821" />
      </svg>
    </div>
  );
};